import React, { useEffect, useRef } from "react";
import { Toast } from "primereact/toast";
import { subscribeNotifications } from "../../services/notificationBus";

export default function GlobalNotifications() {
  const toast = useRef(null);
  useEffect(() => subscribeNotifications((message) => toast.current?.show(message)), []);
  return (
    <Toast
      ref={toast}
      position="top-right"
      className="teamassess-toast"
      baseZIndex={3000}
      pt={{
        message: { role: "status", "aria-live": "polite", "aria-atomic": "true" },
        closeButton: { "aria-label": "Cerrar aviso" },
      }}
    />
  );
}
